import Assets from "./assets";
import UI from "./ui";
import Utils from "./utils";
import Games from "./games";
import Search, { Sort } from "./search";
import Bazaar from "./bazaar";

export default {
    i18n: {
        init() {
            return UI.initI18n();
        },
    },
    rrule: {
        scripts: "/lib/rrule.js",
    },
    vue: {
        init() {
            const tVue = function (...args) {
                // Use t_vue but fallback to original translate function to avoid issue during server update
                // where the client file loaded might come from a different server with the old code
                // as it would break the entire site during the update (and browser cache) if t doesn't exist
                return Utils.t_vue ? Utils.t_vue(...args) : UI.i18n.translate(...args); // Escaping handled by Vue
            };
            Vue.use({
                install() {
                    Vue.prototype.Utils = Utils;
                    Vue.prototype.UI = UI;
                    Vue.prototype.Assets = Assets;
                    Vue.prototype.Games = Games;
                    Vue.prototype.Search = Search;
                    Vue.prototype.Bazaar = Bazaar;
                    Vue.prototype.Sort = Sort;
                    // Expose translation function
                    Vue.prototype.t = tVue;
                },
            });
            Vue.filter("capitalize", Utils.capitalize);
            Vue.filter("t", tVue);
            Vue.config.devtools = process.env.NODE_ENV === "development";
        },
    },
    /* Dynamic loading: routes/jslib */
    vuex: {
        scripts: "/lib/vuex.js",
    },
    "infinite-loading": {
        scripts: "/lib/vue-infinite-loading.js",
    },
    vuescroll: {
        scripts: "/lib/vuescroll.js",
    },
    dompurify: {
        scripts: "/lib/dompurify/purify.js",
        init() {
            // Add a hook to make all links open a new window
            DOMPurify.addHook("afterSanitizeAttributes", function (node) {
                // set all elements owning target to target=_blank
                if ("target" in node) {
                    node.setAttribute("target", "_blank");
                }
                // set non-HTML/MathML links to xlink:show=new
                if (!node.hasAttribute("target") && (node.hasAttribute("xlink:href") || node.hasAttribute("href"))) {
                    node.setAttribute("xlink:show", "new");
                }
            });
        },
    },
    "v-video-embed": {
        scripts: "/lib/v-video-embed.js",
    },
    "simple-markdown": {
        dependencies: ["dompurify"],
        scripts: ["/lib/marked.js", "/lib/marked-smartypants.js"],
        init() {
            // `marked` v4 moved the function from top level to `marked.parse()`, while
            // v5 moved previous functionality to activable plugins. Initialize accordingly.
            if (typeof marked === "object" && typeof marked.parse === "function") {
                // Enable `smartypants` and disable deprecated and unused plugins
                marked.use(markedSmartypants.markedSmartypants(), { headerIds: false, mangle: false });
                window.marked = marked.parse;
            }
        },
    },
    "simple-markdown-editor": {
        dependencies: ["simple-markdown"],
        scripts: ["/lib/simplemde.js", "/lib/vue-simplemde.js"],
        styles: "/lib/simplemde.css",
        init() {
            VueComponents["VueSimpleMDE"] = Vue.component("VueSimpleMde", window.VueSimpleMDE);
        },
    },
    turndown: {
        scripts: "/lib/turndown.js",
    },
    "tinymce-vue": {
        scripts: ["/lib/tinymce/tinymce.js", "/lib/w-tinymce-vue.js"],
        init() {
            VueComponents["TinyMCE"] = Vue.component("TinyMce", window["w-tinymce-vue"]);
        },
    },
    "event-emitter": {
        scripts: "https://unpkg.com/eventemitter3@4.0.7/index.js",
    },
    "date-picker": {
        scripts: "/lib/vue2-datepicker.js",
        styles: "/lib/vue2-datepicker.css",
    },
    "vue-multiselect": {
        scripts: "/lib/vue-multiselect.js",
        styles: "/lib/vue-multiselect.css",
        init() {
            VueComponents["vue-multiselect"] = Vue.component("VueMultiselect", window.VueMultiselect.default);
        },
    },
    draggable: {
        scripts: ["/lib/sortable.js", "/lib/vue-draggable.js"],
    },
    "vue-slider": {
        scripts: "/lib/vue-slider.js",
        styles: "/lib/vue-slider.css",
        init() {
            VueComponents["VueSlider"] = Vue.component("VueSlider", window["vue-slider-component"]);
        },
    },
    "file-saver": {
        scripts: "/lib/file-saver.js",
    },
};
